import Service from "../Service";

const resource = "TicRequirement/";

export default {
    save(cmp, requestID) {
        return Service.post(resource + "save", cmp, {
            params: { requestID: requestID },
        });
    },

    pagination(parameters, requestID) {
        return Service.post(resource + "pagination", parameters, {
            params: { requestID: requestID },
        });
    },

    getUserDetail(usrID, requestID) {
        return Service.get(resource + "userDetail", {
            params: { usrID: usrID, requestID: requestID },
        });
    },

    upload(requestID, files) {
        return Service.post(resource + "upload", files, {
            params: { requestID: requestID },
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
    },

    download(fileName, requestID) {
        return Service.post(resource + "download", {}, {
            responseType: "blob",
            headers: {
                "Content-Type": "application/json",
            },
            params: {
                fileName: fileName,
                requestID: requestID,
            },
        });
    },

    saveVote(voteObj, requestID) {
        return Service.post(resource + "saveVote", voteObj, {
            params: { requestID: requestID }
        });
    },

    getVotes(reqID, requestID) {
        return Service.get(resource + "getVotes", {
            params: { reqID: reqID, requestID: requestID }
        });
    },

    getHistory(reqID, requestID) {
        return Service.get(resource + "getHistory", {
            params: { reqID: reqID, requestID: requestID }
        });
    },

    getDashboardKPIs(requestID, filter = {}) {
        return Service.get(resource + "getDashboardKPIs", {
            params: {
                requestID: requestID,
                usrID: filter.usrID || null,
                areParentID: filter.areParentID || null,
                reqProject: filter.reqProject || null
            }
        });
    }
};
